import type { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { Button, TextButton } from "@amzn/storm-ui";
import { sparkle } from "@amzn/storm-ui-icons";
import React from "react";
import styled from "styled-components";

import type { G4sPlacement } from "../../constants/g4sPlacement";

import { DeckDecorationWithLanguageModal } from "./DeckDecorationWithLanguageModal";

const AiTextButton = styled(TextButton)`
    color: ${({ theme, disabled }) =>
        disabled ? theme.color.gray[300] : "purple"} !important;
    display: "flex";
    paddingright: "15px";
`;

export interface DeckDecorationWithLanguageModalButtonProps {
    documentUrl?: string;
    documentUrlAsync?: () => Promise<string>;
    identifier: string;
    insightType: InsightType;
    placement: G4sPlacement;
}

export const DeckDecorationWithLanguageModalButton: React.FunctionComponent<
    DeckDecorationWithLanguageModalButtonProps
> = ({ documentUrl, identifier, insightType, placement, documentUrlAsync }) => {
    const [modalOpen, setModalOpen] = React.useState(false);

    return (
        <>
            <DeckDecorationWithLanguageModal
                open={modalOpen}
                identifier={identifier}
                documentUrl={documentUrl}
                documentUrlAsync={documentUrlAsync}
                placement={placement}
                insightType={insightType}
                handleClose={() => {
                    void setModalOpen(false);
                }}
            />
            <Button
                data-testid="deck-decoration-with-language-button"
                onClick={() => {
                    setModalOpen(true);
                }}
                iconStart={sparkle}
                variant="primary"
                loading={false}
                loadingLabel="Summarizing Deck"
            >
                Summarize Deck
            </Button>
        </>
    );
};
